const initialState = {
	year: '',
	appointments: [],
	contracts: [],
	currentContract: null,
	viewPDF: false,
	viewCheckPDF: false,
	validationResult: null,
	viewTAndC: false,
	isLoaded: false
};

export default initialState;
